import React from 'react';
const SearchAppearanceIcon = () => {
  return <svg style={{scale: '1.3'}} width="21" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.05998 5.84399H7.73584V8.51985H5.05998V5.84399ZM8.73929 5.84399H11.4151V8.51985H8.73929V5.84399ZM5.05998 9.5233H7.73584V12.1992H5.05998V9.5233ZM8.73929 9.5233H11.4151V12.1992H8.73929V9.5233Z" fill="#5C5F62"/>
  <path d="M13.5893 3.66986H2.88584C2.14998 3.66986 1.54791 4.27193 1.54791 5.00779V13.0354C1.54791 13.7712 2.14998 14.3733 2.88584 14.3733H13.5893C14.3251 14.3733 14.9272 13.7712 14.9272 13.0354V5.00779C14.9272 4.27193 14.3251 3.66986 13.5893 3.66986ZM13.5893 13.0354H2.88584V5.00779H13.5893V13.0354Z" fill="#5C5F62"/>
  </svg>
  

};

export default SearchAppearanceIcon;

